import angular from 'angular';

angular.module('cloudX').directive('cxCurrencySelect', function() {
  return {
    restrict: 'E',
    template:
      '<a href="" editable-currency="value" onbeforesave="beforeSave({newValue:$data})" onaftersave="afterSave({newValue:$data})" blur="submit" edit-disabled="disabled"> <span ng-show="value" >{{value}}</span> ' +
      '<i class="glyphicon glyphicon-pencil" ng-show="!value"></i> </a>',
    scope: {
      value: '=data',
      beforeSave: '&',
      afterSave: '&',
      disabled: '=?',
    },
  };
});
